import "bootstrap-icons/font/bootstrap-icons.css";

import parse from "html-react-parser";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import { LinkButton, NormalButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { InfoItem } from "components/pf";
import { handleOpenPdf } from "utils";
import { eligibility } from "constants/eligibility";
import { ASSETS_BASE_URL } from "constants";
import { FaqListPFHomeOne } from "constants/faq";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";
import AccordionSimple from "components/accordion/AccordionSimple";
import useStore from "stores/Store";

import pf_form from "assets/pdf/property-financing/HF Application Form.pdf";
import pf_pds from "assets/pdf/property-financing/PDS-H1A_effective28Nov2023.pdf";
import outline_check from "assets/images/outline_check.svg";

function PropertyFinancingHomeOne() {
  const { faqRef } = useStore();
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Property Financing-i"
          title={`  <span className="jumbotron-subtitle-2">
                Home
              </span>      
              One Account
             `}
          buttonText="Let's connect! "
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Consolidate your financial obligations by refinancing your
              property. Talk to us to see how you can enjoy greater financial
              freedom.
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">
                  Competitive Financing Rate
                </div>
                <div className="column-subheader-2">
                  Lower your financing cost
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Improve Cashflow</div>
                <div className="column-subheader-2">
                  Increase your monthly disposable income and improve cashflow
                  to meet your financial needs
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Peace of Mind</div>
                <div className="column-subheader-2">
                  Peace of mind with a consolidated financial obligation
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Financial Freedom</div>
                <div className="column-subheader-2">
                  Enjoy more financial freedom {" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Available Package</div>
                <div className="column-subheader-2">
                  Zero entry cost package available{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Need More Info?</div>
                <div className="column-subheader-2">
                  {/* <NormalButton
                    text="Read our FAQs"
                    onClick={() =>{
                      if (faqRef.current) {
                        const offset = 156; // Adjust this value as needed
                        const topPosition = faqRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({
                          top: topPosition,
                          behavior: 'smooth'
                        });
                      }
                    }}
                    style={{ fontSize: "14px", margin: "10px 0 20px" }}
                  /> */}
                  <Link className="link_benefits d-block no-wrap" to={"/tnc"}>
                    *Terms & Conditions
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Shariah Contract</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah Contract</div>
                <div className="column-subheader-2">
                  Commodity Murabahah (via Tawarruq arrangement)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Eligibility</h3>
          </Col>
          <Col md={8}>
            <ScrollAnimatedProgressBar data={eligibility}>
              {eligibility.points.eligibilityhomeone.description.map(
                (benefit, index) => (
                  <div className="animated-list z-1">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </ScrollAnimatedProgressBar>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Requirements</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-5 col-12 custom-column">
                <div className="column-header-2">Salaried Employees: </div>
                <div className="column-subheader pt-3">
                  <li>
                    Photocopy of <b>IC / Identification document</b>
                  </li>
                  <li>
                    Latest 3 months <b>latest 3 months salary slip</b> and{" "}
                    <b>bank statement showing salary credited</b>
                  </li>
                  <li>
                    Latest <b>EPF statement</b>
                  </li>
                  <li>
                    Sales & <b>Purchase Agreement</b> / Booking receipt
                    <li>
                      <b>Property Title</b>
                    </li>
                  </li>
                </div>
              </div>
              <div className="col-xl-5 col-12 custom-column">
                <div className="column-header-2">Self-employed:</div>
                <div className="column-subheader pt-3">
                  <li>
                    Photocopy of <b>IC / Identification document</b>
                  </li>
                  <li>
                    Latest 6 months <b>bank statement</b>
                  </li>
                  <li>
                    <b>Business registration Form</b>
                  </li>
                  <li>
                    Copy of <b>Income Tax</b> & proof of tax payment
                  </li>
                  <li>
                    Sales & <b>Purchase Agreement</b> / Booking receipt
                    <li>
                      <b>Property Title</b>
                    </li>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <InfoItem
                header="Retrieval / Photocopy of Security Documents"
                subheader="Actual Cost"
              />
              <InfoItem
                header="EPF Withdrawal Confirmation Letter Fee"
                subheader="RM10.00 per request"
              />

              <InfoItem
                header="Annual Financing Statement Fee"
                subheader="RM 5.00 per request (Ad-hoc)"
              />
              <InfoItem
                header="Redemption Statement Fee"
                subheader="RM 10.00 per request"
              />
              <InfoItem
                header="Brokerage Fee"
                subheader="0.0008% of the principal amount of financing/disbursement"
              />
              <InfoItem header="Processing Fee" subheader="Nil" />
              <InfoItem
                header="Legal Fees"
                subheader="as per Legal Firm Schedule"
              />
              <InfoItem
                header="Stamp Duty"
                subheader="as per Stamp Duty Act 1949"
              />
              <InfoItem
                header="Takaful"
                subheader="Subject to the financing amount, tenure and age"
              />
              <InfoItem
                header="Balance Transfer Fee (Lawyer Fee)"
                subheader="Actual Cost"
              />
              <InfoItem
                header="ARNT Fee (or Agency Fee)"
                subheader="RM 1.00 per transaction"
              />
            </div>
            <div className="link-button-row pt-5">
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() => handleOpenPdf(pf_pds)}
              />
              <LinkButton
                text="Download Application Form"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/HF_Application_Form.pdf `
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      {/* <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4 mb-3">
            <h3>Frequently Asked Questions</h3>
          </div>
          <div className="col-xl-8">
            <AccordionSimple data={FaqListPFHomeOne} />
          </div>
        </div>
      </section> */}

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default PropertyFinancingHomeOne;
